import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  // Spec §0.6.13 calls for an aerospace-themed custom SVG per context, not a
  // generic Lucide icon. Caller passes the SVG (or any node) — the colour
  // and 56-px sizing are applied by the wrapper class.
  icon: ReactNode;
  title: string;
  message?: string;
  // Optional CTA — usually a <Button variant="filled-accent">…</Button>.
  cta?: ReactNode;
}

export function EmptyState({ icon, title, message, cta }: EmptyStateProps) {
  return (
    <div className={styles.root}>
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      <h2 className={styles.title}>{title}</h2>
      {message ? <p className={styles.message}>{message}</p> : null}
      {cta ? <div className={styles.cta}>{cta}</div> : null}
    </div>
  );
}
